// extracted by mini-css-extract-plugin
module.exports = {"DarkTheme__menu___mf4zp":"DarkTheme__menu___mf4zp","DarkTheme__title___12Lje":"DarkTheme__title___12Lje"};